import script from "./message1.vue?vue&type=script&setup=true&lang=js"
export * from "./message1.vue?vue&type=script&setup=true&lang=js"

import "./message1.vue?vue&type=style&index=0&id=1a487edd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a487edd"]])

export default __exports__